export enum TYPES {
  PUSH_NOTIFICATION = 'pushNotification',
  POP_NOTIFICATION = 'popNotification',
}

export default TYPES
